import { createSelector } from 'reselect'

import { selectGroupConfig } from 'selectors/selectGroupConfig'

export const selectPlatformObservabilityLinks = createSelector([selectGroupConfig], (groupConfig) =>
  groupConfig.get('platform_observability_links')
)
